@if (isMobile()) {
  <proffeo-ui-button
    (clicked)="onStartTaskCreation()"
    variant="accent"
    fontIcon="add"
    class="inline-flex z-50 fixed bottom-5 right-5"
  ></proffeo-ui-button>
}

<div
  [class.flex-1]="!isMobile()"
  [class.min-h-0]="!isMobile()"
  class="relative flex w-full gap-5"
>
  @if (!isMobile()) {
    <as-split
      (dragEnd)="onPaneDragEnd($event)"
      [gutterSize]="12"
      direction="horizontal"
      unit="percent"
      class="task-split h-full min-h-0 w-full overflow-hidden"
    >
      <as-split-area
        [size]="listPaneSize()"
        [visible]="listPaneSize() > 0"
        [class.hidden]="listPaneSize() === 0"
        [minSize]="activeTask() ? listPaneMinSize : 100"
        [maxSize]="activeTask() ? 80 : 100"
      >
        <div
          [class.overflow-hidden]="showDesktopTable()"
          [class.overflow-y-auto]="!showDesktopTable()"
          class="flex h-full min-h-0 min-w-0 flex-col gap-2 p-1"
        >
          <ng-container *ngTemplateOutlet="taskList" />
        </div>
      </as-split-area>

      @if (activeTask()) {
        <as-split-area
          [size]="detailsPaneSize()"
          [visible]="detailsPaneSize() > 0"
          [class.hidden]="detailsPaneSize() === 0"
          [minSize]="detailsPaneMinSize()"
        >
          <div class="@container/details flex h-full min-h-0 flex-col gap-2 overflow-hidden p-1">
            <proffeo-task-details-content
              #taskDetailsContent
              [(currentTabIndex)]="detailsTab"
              (activityReopenRequested)="onReopenActivityPanel()"
              [showReopenActivity]="!isActivityPanelVisible()"
              animate.enter="fade-in"
            ></proffeo-task-details-content>
          </div>
        </as-split-area>

        @if (isActivityPanelOpen()) {
          <as-split-area
            [size]="activityPaneSize()"
            [visible]="isActivityPanelVisible()"
            [class.hidden]="!isActivityPanelVisible()"
            [minSize]="activityPaneMinSize()"
            [maxSize]="detailsPaneSize() === 0 ? 100 : 50"
          >
            <div class="flex h-full min-h-0 flex-col overflow-hidden p-1">
              <proffeo-task-timeline
                (panelClosed)="onCloseActivityPanel()"
                [task]="activeTask()"
                [taskActivities]="taskActivities()"
                [showClose]="true"
                class="h-full min-h-0 w-full"
              />
            </div>
          </as-split-area>
        }
      }
    </as-split>
  } @else if (!activeTask()) {
    <div class="flex! w-full min-w-0 flex-col gap-2 p-1">
      <ng-container *ngTemplateOutlet="taskList" />
    </div>
  } @else {
    <div class="flex w-full min-w-0 flex-col gap-2 overflow-x-hidden">
      <proffeo-task-details-content
        #taskDetailsContent
        [(currentTabIndex)]="detailsTab"
        animate.enter="fade-in"
      ></proffeo-task-details-content>
      <proffeo-task-timeline
        [constrainHeight]="false"
        [task]="activeTask()"
        [taskActivities]="taskActivities()"
        [showClose]="false"
        class="proffeo-ui-surface-card flex p-2"
      ></proffeo-task-timeline>
    </div>
  }
</div>

<ng-template #taskList>
  @if (showDesktopTable()) {
    <div class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
      <proffeo-task-table
        (statusChanged)="onStatusChanged($event)"
        (priorityChanged)="onPriorityChanged($event)"
        (taskStartDateSelected)="onTaskStartDateSelected($event)"
        (taskEndDateSelected)="onTaskEndDateSelected($event)"
        (industryClicked)="onIndustryClicked($event)"
        (locationClicked)="onLocationClicked($event)"
        (changeGroupClicked)="onChangeGroupClicked($event)"
        (changeUsersClicked)="onChangeUsersClicked($event)"
        (sortChange)="onTableSortChange($event)"
        [tasks]="rootTasks()"
        [timelineEnabled]="viewMode() === 'timeline'"
        [taskTypes]="activeCompanyTaskTypes()"
        [orderBy]="taskFiltersState.orderBy()"
        [order]="taskFiltersState.order()"
        class="min-h-0 min-w-0 w-full flex-1"
      />
    </div>
  } @else {
    @if (!isMobile()) {
      <div class="flex w-full min-w-0 shrink-0 flex-wrap items-center gap-2">
        <proffeo-task-sort-controls
          [compact]="!!activeTask()"
          class="min-w-0 flex-1"
        />
      </div>
    }

    <proffeo-task-cards-list
      [(expandedNodes)]="expandedNodes"
      (statusChanged)="onStatusChanged($event)"
      (priorityChanged)="onPriorityChanged($event)"
      (taskStartDateSelected)="onTaskStartDateSelected($event)"
      (taskEndDateSelected)="onTaskEndDateSelected($event)"
      (taskProgressSelected)="onTaskProgressSelected($event)"
      (industryClicked)="onIndustryClicked($event)"
      (locationClicked)="onLocationClicked($event)"
      (changeGroupClicked)="onChangeGroupClicked($event)"
      (changeUsersClicked)="onChangeUsersClicked($event)"
      [tasks]="rootTasks()"
      [taskTypes]="activeCompanyTaskTypes()"
      [compactMode]="!!activeTask()"
      [mobileCompact]="viewMode() === 'table'"
      [showSortControls]="false"
      [listLoading]="isLoading()"
    />
  }

  <mat-paginator
    (page)="changePage($event)"
    [length]="$safeNavigationMigration(allTasks()?.total)"
    [pageIndex]="taskFiltersState.page()"
    [pageSize]="taskFiltersState.limit()"
    [pageSizeOptions]="[25, 50, 75, 100]"
    [hidePageSize]="isCompactPagination()"
    [showFirstLastButtons]="!isCompactPagination()"
    class="flex w-full shrink-0 items-center justify-center bg-transparent"
  ></mat-paginator>
</ng-template>
